<template>
  <div class="container">
    <app-page-search :title="title"></app-page-search>
    <div class="in-progress">
      В данный момент раздел находится в стадии заполнения.
    </div>
  </div>
</template>

<script>
import { AppPageSearch } from "@/components";

export default {
  name: "BestPractice",
  components: { AppPageSearch },
  data: () => ({
    title: "Лучшие практики"
  })
};
</script>

<style lang="scss" scoped>
.in-progress {
  text-align: center;
  margin-top: 100px;
}
</style>
